// Recharts custom tooltip + label components shared across the dashboard.

export function TooltipBox({ active, payload, label }) {
  if (!active || !payload?.length) return null;
  return (
    <div className="rounded-lg border border-[#E6EBE8] bg-white px-3 py-2 shadow-sm">
      <div className="text-xs font-semibold text-[#1B3B2E]">{label}</div>
      {payload.map((p) => (
        <div key={p.dataKey} className="text-xs text-[#3D4F46] mt-1">
          <span className="font-mono-data">{p.value}</span>{" "}
          <span className="text-[#5C746A]">{p.name}</span>
        </div>
      ))}
    </div>
  );
}

export function CurrencyTooltip({ active, payload, label }) {
  if (!active || !payload?.length) return null;
  const fmt = new Intl.NumberFormat("en-CA", {
    style: "currency",
    currency: "CAD",
    currencyDisplay: "narrowSymbol",
    maximumFractionDigits: 2,
  });
  // If the payload row carries a Pct field (e.g. from the Drug Breakdown
  // bar chart) surface it as a secondary line so the user gets both the
  // dollar amount AND the share of total.
  const row = payload[0]?.payload || {};
  return (
    <div className="rounded-lg border border-[#E6EBE8] bg-white px-3 py-2 shadow-sm">
      <div className="text-xs font-semibold text-[#1B3B2E]">{label}</div>
      {payload.map((p) => (
        <div key={p.dataKey} className="text-xs text-[#3D4F46] mt-1">
          <span className="font-mono-data">{fmt.format(p.value || 0)}</span>{" "}
          <span className="text-[#5C746A]">{p.name}</span>
        </div>
      ))}
      {typeof row.Pct === "number" ? (
        <div className="text-[11px] text-[#2B5E4A] font-mono-data font-semibold mt-1">
          {row.Pct}% of total
        </div>
      ) : null}
    </div>
  );
}

// Custom Recharts Y-axis tick that renders a single non-wrapping text and
// truncates with an ellipsis if longer than `maxChars`. Prevents drug names
// like "ODAN-METHADONE U" from splitting onto two lines.
export function DrugTick({ x, y, payload, maxChars = 18, countMap }) {
  const value = payload?.value ?? "";
  const display =
    value.length > maxChars ? `${value.slice(0, maxChars - 1)}…` : value;
  const count = countMap?.[value];
  return (
    <g transform={`translate(${x},${y})`}>
      <title>{value}</title>
      <text
        x={-4}
        y={0}
        dy={count != null ? -2 : 4}
        textAnchor="end"
        fill="#3D4F46"
        fontSize={11}
        style={{ whiteSpace: "nowrap" }}
      >
        {display}
      </text>
      {count != null ? (
        <text
          x={-4}
          y={0}
          dy={12}
          textAnchor="end"
          fill="#8A9C93"
          fontSize={10}
          fontFamily="JetBrains Mono"
          style={{ whiteSpace: "nowrap" }}
        >
          {count} disp.
        </text>
      ) : null}
    </g>
  );
}
